import * as React from "react";
import type { SVGProps } from "react";
const SvgMore2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 3 10"
    {...props}
  >
    <path
      fill="#4FD08F"
      d="M1.81 2.381A1.19 1.19 0 1 1 1.81 0a1.19 1.19 0 0 1 0 2.381M1.81 6.19a1.19 1.19 0 1 1 0-2.38 1.19 1.19 0 0 1 0 2.38M1.81 10a1.19 1.19 0 1 1 0-2.38 1.19 1.19 0 0 1 0 2.38"
    />
  </svg>
);
export default SvgMore2;
